import BonusesModel from '../Apis/Bonuses'
import Controller from './Controller'

export default class BonusesController extends Controller {
  constructor() {
    super(new BonusesModel())
  }
}
